import React from 'react'

export const CinemaConfig = {
  routes: [
    {
      path: "/cinema/create",
      component: React.lazy(() => import('./CinemaEdit'))
    },
    {
      path: "/cinema/edit/:filmId",
      component: React.lazy(() => import('./CinemaEdit'))
    },
    {
      path: "/cinema/list",
      component: React.lazy(() => import('./CinemaListScreen'))
    },
    //Saloon
    // {
    //   path: "/saloon/create",
    //   component: React.lazy(() => import('./SaloonEdit'))
    // },
    {
      path: "/saloon/edit/:saloonId",
      component: React.lazy(() => import('./SaloonEdit'))
    },
    {
      path: "/saloon/list",
      component: React.lazy(() => import('./SaloonListScreen'))
    },
    //Session
    {
      path: "/session/list",
      component: React.lazy(() => import('./SessionListScreen'))
    }
  ]
};

